import React, { useEffect, useState } from 'react'
import { archiveSalary, getSalaryList } from '../../../actions/utilitiesAction'
import ListSalary from '../../../component/Utilities/Salary/SalaryList'
import constant from '../../../constant'
import queryString from 'query-string'
import { useLocation } from "react-router-dom";

const SalaryList = () => {

    const [list, setList] = useState(null)
    const [count, setCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [keyword, setKeyword] = useState('')
    const [showLoader, setShowLoader] = useState(false)
    const location = useLocation()


    useEffect(() => {
        const qParams = queryString.parse(location.search)
        getSalaryLists(qParams?.p ? qParams?.p : qParams?.pageno ? qParams.pageno : currentPage)
        document.title = constant.title.SalaryList
    }, [currentPage])

    const getSalaryLists = (page) => {
        setShowLoader(true)
        getSalaryList({ pageNumber: page, KEYWORD: keyword }).then((res) => {
            if (res.status) {
                setShowLoader(false)
                setList(res.result.list)
                setCount(res.result.count)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    const updateStatus = (model) => {
        archiveSalary(model).then((res) => {
            if (res.status) {
                getSalaryLists(currentPage, "")
            } else {
                alert(res.error)
            }
        }).catch((err) => {
            alert(err)
        })
    }

    return (
        <React.Fragment>
            <ListSalary
                list={list}
                updateStatus={updateStatus}
                getSalaryLists={(page => getSalaryLists(page))}
                count={count}
                setPage={setCurrentPage}
                keyword={setKeyword}
                showLoader={showLoader}
            />
        </React.Fragment>

    )
}
export default SalaryList;